import { useCallback } from "react";

const useMonthLabels = (isMobile: boolean, months: Array<{ fields: { id: number; name: string } }>) => {
    const callbackMonthLabels = useCallback(
        (_: any, idx: number): string => {
            if (isMobile && idx % 2 !== 0) {
                return "";
            }

            const label = months.find(item => item.fields.id === idx + 1);
            if (label) {
                return label.fields.name;
            }
            return `${idx + 1}`;
        },
        [isMobile, months],
    );

    return { callbackMonthLabels };
};

export default useMonthLabels;
